import { ReactComponent as lockIcon } from './assets/icon-lock.svg';
import bgAuthMain from './assets/bg-auth-main.jpg';
import bgAuthMainSmall from './assets/bg-auth-main-small.jpg';
import logo from './assets/logo.svg';
import cardApplicationAboutYou from './assets/card-application-about-you.jpg';
import cardApplicationDeliveries from './assets/card-application-deliveries.jpg';
import cardApplicationEmployment from './assets/card-application-employment.jpg';
import cardApplicationHealth from './assets/card-application-health.jpg';
import cardApplicationPersonalHistory from './assets/card-application-personal-history.jpg';
import cardApplicationPersonalInfo from './assets/card-application-personal-info.jpg';
import cardApplicationPregnancyHistory from './assets/card-application-pregnancy-history.jpg';
import cardApplicationSignatureDisclosure from './assets/card-application-signature-disclosure.jpg';
import cardApplicationSurrogacyJourney from './assets/card-application-surrogacy-journey.jpg';
import applicationPdfLogoMain from './assets/logo-main@2x.png';
import applicationPdfLogoSmallWhite from './assets/logo-small-white@2x.png';
import cardQuestionnaireAcknowledgement from './assets/card-questionnaire-acknowledgement.jpg';
import cardQuestionnaireCoupleQuestions from './assets/card-questionnaire-couple-questions.jpg';
import cardQuestionnaireDefault from './assets/card-questionnaire-default.jpg';
import cardQuestionnaireFinal from './assets/card-questionnaire-final.jpg';
import cardQuestionnairePathToParenthood from './assets/card-questionnaire-path-to-parenthood.jpg';
import cardQuestionnaireSecondIntendedParent from './assets/card-questionnaire-second-intended-parent.jpg';
import cardQuestionnaireSurrogacyJourney from './assets/card-questionnaire-surrogacy-journey.jpg';
import cardQuestionnaireUploadPage from './assets/card-questionnaire-upload-page.jpg';
import questionnairePdfLogoMain from './assets/logo-main.png';
import authSignUpCard from './assets/img-card-sign-up.jpg';
import authSignUpParentCard from './assets/img-card-sign-up-parent.png';
import { TenantAssets, TenantSvgAssets } from '../types';

/** §4A.2 — ISC's 26 tenant-varying `src/` assets, moved verbatim (`git mv`, byte-identical) from
 *  their pre-04 paths. Not re-compressed (see PLAN §4A.2 on `bgAuthMain`'s 3.69MB size). */
export const iscAssets: TenantAssets = {
  bgAuthMain,
  bgAuthMainSmall,
  logo,
  cardApplicationAboutYou,
  cardApplicationDeliveries,
  cardApplicationEmployment,
  cardApplicationHealth,
  cardApplicationPersonalHistory,
  cardApplicationPersonalInfo,
  cardApplicationPregnancyHistory,
  cardApplicationSignatureDisclosure,
  cardApplicationSurrogacyJourney,
  applicationPdfLogoMain,
  applicationPdfLogoSmallWhite,
  cardQuestionnaireAcknowledgement,
  cardQuestionnaireCoupleQuestions,
  cardQuestionnaireDefault,
  cardQuestionnaireFinal,
  cardQuestionnairePathToParenthood,
  cardQuestionnaireSecondIntendedParent,
  cardQuestionnaireSurrogacyJourney,
  cardQuestionnaireUploadPage,
  questionnairePdfLogoMain,
  authSignUpCard,
  authSignUpParentCard,
};

/** D4 — the only tenant-varying `ReactComponent` SVG import, statically imported per tenant. */
export const iscSvgAssets: TenantSvgAssets = {
  lockIcon,
};
